"use client"
import { UserIcon, PencilIcon } from "lucide-react"

interface ProfileTabsProps {
  activeTab: string
  setActiveTab: (tab: string) => void
}

export default function ProfileTabs({ activeTab, setActiveTab }: ProfileTabsProps) {
  const tabs = [
    { id: "about", label: "About", icon: UserIcon },
    { id: "edit", label: "Profile", icon: PencilIcon },
    { id: "updatePassword", label: "Password", icon: PencilIcon },
  ]

  return (
    <div className="flex gap-3 p-4 px-2 md:px-5 w-full  justify-start">
      {tabs.map((tab) => (
        <button
          key={tab.id}
          onClick={() => setActiveTab(tab.id)}
          className={`flex items-center gap-1 sm:gap-2  px-4 py-2 rounded-md text-xs mobile:text-sm lg:text-xs xl:text-sm ${activeTab === tab.id
            ? "bg-[#3FBBA3] text-white"
            : "dark:bg-gray-700 bg-gray-200 dark:text-gray-300 text-gray-700"
            }`}
        >
          <tab.icon className="w-4 h-4" />
          {tab.label.split(" ")[0]}
        </button>
      ))}
    </div>
  )
}

